import React from 'react';
import { Card, CardContent } from '../ui/card';

export const ContactInfoCard = ({ icon: Icon, title, children }) => (
  <Card className="border-0 shadow-lg hover:shadow-xl transition-shadow">
    <CardContent className="p-6">
      <div className="flex items-start gap-4">
        <div className="w-12 h-12 bg-gradient-to-br from-cyan-500 to-teal-600 rounded-lg flex items-center justify-center flex-shrink-0">
          <Icon className="w-6 h-6 text-white" />
        </div>
        <div>
          <h3 className="font-bold text-gray-900 mb-2">{title}</h3>
          {children}
        </div>
      </div>
    </CardContent>
  </Card>
);

export const ContactLinkList = ({ items, hrefPrefix, linkClass = '' }) => (
  <div className="space-y-1">
    {items.map(({ caption, value }) => (
      <div key={value}>
        <div className="text-xs text-gray-500">{caption}</div>
        <a href={`${hrefPrefix}${value}`} className={`text-cyan-600 hover:text-cyan-700 font-medium ${linkClass}`}>
          {value}
        </a>
      </div>
    ))}
  </div>
);

export default ContactInfoCard;
